export class WrappedFirestoreError extends Error {
  isHandled: boolean = false
  code?: string

  constructor(message: string, code?: string) {
    super(message)
    this.code = code
  }
}

export class StorageFetchError extends Error {
  constructor(message: string, options?: ErrorOptions) {
    super(message, options)
    this.name = 'StorageFetchError'
  }
}
